export const OPEN_HELP_CENTER_EVENT = 'help/open-help-center';
